import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePartner } from "features/Promotion/promotionSlice";
import { useForm } from "react-hook-form";
import {
  FirstName,
  LastName,
  Age,
  Phone,
  Gender,
  checkPromotionSets,
  FirstNameKana,
  LastNameKana,
  Email
} from "features/Promotion/field-input";

const ModalUpdatePartner = ({
  closeFn,
  open = null,
  partnerInfo = null,
  setPartnerInfo,
}) => {
  const dispatch = useDispatch();
  const [errorDisplay, setErrorDisplay] = useState([]);

  let errorValidate = [];
  const { promotion_set, promotion } = useSelector((state) => state.promotion);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const checkPartner = (data) => {
    errorValidate = [];
    const { age, gender } = data;
    const { promotion_set_id } = partnerInfo;

    errorValidate = checkPromotionSets(
      promotion,
      promotion_set_id,
      age,
      gender
    );

    setErrorDisplay(errorValidate);
    return errorValidate.length < 1 ? true : false;
  };

  const handleClearErrorAge = () => {
    if (errorDisplay) {
      setErrorDisplay([]);
    }
  };

  const onSubmit = (data, e) => {
    if (checkPartner(data)) {
      dispatch(
        updatePartner({
          partner: partnerInfo,
          update_partner: {
            promotion_set_id: partnerInfo?.promotion_set_id,
            ...data,
          },
        })
      );
      setPartnerInfo(null);
      setErrorDisplay([]);
      reset();
      closeFn(e);
    }
  };

  const closeModal = (e) => {
    errorValidate = [];
    setErrorDisplay([]);
    reset();
    closeFn(e);
  };

  return (
    partnerInfo &&
    open && (
      <form onSubmit={handleSubmit(onSubmit)} className="modal rounded-8 active">
        <div className="modal-body">
          <div className="title mt-2 text-black">同行者の情報を修正する</div>

          <div className="px-3 px-md-5 my-4">
            {errorDisplay.length > 0 &&
              errorDisplay.map((err, index) => (
                <div key={index} className="alert alert-danger mt-2">
                  {err}
                </div>
              ))}
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">お名前</label>
                <div className="row gx-3">
                  <div className="col-12 col-md-6">
                    <LastName
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <FirstName
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className="row gx-3 mt-2">
                  <div className="col-12 col-md-6">
                    <LastNameKana
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <FirstNameKana
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  年齢 <span></span>
                  <span>半角数字</span>
                </label>
                <div className="row gx-3">
                  <div className="w-82">
                    <Age
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                      errorAge={errorDisplay.length > 0 ? true : false}
                      clearError={handleClearErrorAge}
                    />
                  </div>
                </div>
                {errors?.age && (
                  <div className="alert alert-danger mt-2">
                    {errors.age?.message}
                  </div>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">性別</label>
                <div>
                    <Gender
                      register={register}
                      value="1"
                      id="1"
                      label="男性"
                      partnerInfo={partnerInfo}
                      errors={errors}
                    />
                    <Gender
                      register={register}
                      value="2"
                      id="2"
                      label="女性"
                      partnerInfo={partnerInfo}
                      errors={errors}
                    />
                </div>
                {errors?.gender && (
                  <div className="alert alert-danger mt-2">
                    {errors.gender?.message}
                  </div>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  電話番号<span>[必須]</span>
                  <span>半角数字・ハイフンなし</span>
                </label>
                <div className="row gx-2">
                  <div className="col-12 col-md-9">
                    <Phone
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                メールアドレス<span></span>
                  <span></span>
                </label>
                <div className="row gx-2">
                  <div className="col-12 col-md-9">
                    <Email
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center fs-12 flex-wrap text-red">
            <span> ※身分証を確認させて頂く場合がございます。 </span>
            <span> お間違えのない様にお願いいたします。 </span>
          </div>

          <div className="my-3 text-center">
            <input
              type="submit"
              className="btn-custom red-light"
              value={"修正する"}
            />

            <div onClick={closeModal} className="btn-custom mt-2">
              キャンセル
            </div>
          </div>
        </div>
      </form>
    )
  );
};

export default ModalUpdatePartner;
